import { api } from "./client";

export async function vote(post_id: number, value: 1 | -1 | 0) {
  return api("/vote", "POST", { post_id, value }, true);
}

export async function getMyVotes() {
  return api<Record<string, number>>("/my-votes", "GET", undefined, true);
}
